import { Directive, HostBinding } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusToolbarListHeader], campus-toolbar-list-header',
})
export class ToolbarListHeaderDirective {
  @HostBinding('class.shared-toolbar__list-header')
  hasToolbarListHeader = true;
}
